export default __webpack_public_path__ + "static/media/uke.efd23d1e.png";